import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import MembershipPresenter, {
  MEMBERSHIP_STATES,
} from '../../../../../../presenters/FastCash/MembershipPresenter';

const Header = (props) => {
  const {
    onVisibilityChange,
    membership,
    renderArrow,
    onMembershipUpdate,
    isVisible,
  } = props;

  const canCancelMembership = MembershipPresenter.canCancel(membership);
  const isCanceledMembership = MembershipPresenter.isCanceled(membership);
  const isInactiveMembership = MembershipPresenter.isInactive(membership);
  const membershipId = MembershipPresenter.id(membership);

  const getLabelClassName = (membershipState) => {
    if (membershipState == MEMBERSHIP_STATES.reactivated) return 'label-active';

    return `label-${membershipState}`;
  };

  const membershipTitleClasses = cn('membership-title', {
    ['inactive-membership-title']: isInactiveMembership,
  });

  const membershipLabelClasses = cn(
    'membership-label',
    getLabelClassName(MembershipPresenter.state(membership))
  );

  const handleMembershipCancel = () => {
    const newState = MEMBERSHIP_STATES.canceled;
    const params = { membershipId, state: newState };
    onMembershipUpdate(params);
  };

  const handleMembershipReactivate = () => {
    const newState = MEMBERSHIP_STATES.reactivated;
    const params = { membershipId, state: newState };
    onMembershipUpdate(params);
  };

  return (
    <div className="membership-item">
      <div
        onClick={onVisibilityChange(membershipId)}
        className={membershipTitleClasses}
      >
        Membership
        <span className="membership-period">
          {MembershipPresenter.periodReadable(membership)}
        </span>
        {renderArrow(isVisible)}
      </div>
      <div className="membership-active-action">
        {canCancelMembership && (
          <button className="button delete" onClick={handleMembershipCancel}>
            Cancel Membership
          </button>
        )}
        {isCanceledMembership && (
          <button className="button" onClick={handleMembershipReactivate}>
            Reactivate Membership
          </button>
        )}
        <div className={membershipLabelClasses}>
          {MembershipPresenter.stateReadable(membership)}
        </div>
      </div>
    </div>
  );
};

export default Header;

Header.propTypes = {
  onVisibilityChange: PropTypes.func.isRequired,
  membership: MembershipPresenter.shape().isRequired,
  renderArrow: PropTypes.func.isRequired,
  onMembershipUpdate: PropTypes.func.isRequired,
  isVisible: PropTypes.bool.isRequired,
};
